export default {
  'reportGroups.form.powerBIServerConfigurationId': 'Power BI Server Configuration',
  'reportGroups.form.powerBIReportGroupId': 'PowerBI Report Group Id',
  'reportGroups.permissions.description': 'Add or remove who can access the report group {name}.',
  'reportGroups.form.owner': 'Owner',
};
